import { HttpClient,HttpEventType } from '@angular/common/http';
import { Component, OnInit, ViewChild, ViewChildren, QueryList, ViewContainerRef, ChangeDetectorRef, AfterViewInit, OnDestroy } from '@angular/core';
import { AudioTableService } from '../_services/audio-table.service';
import { AudioFile } from '../_models/audio-file.model';
import { Job } from '../_models/job.model';
import { faEye, faTrash, faDownload, faFolderPlus,faFileWord,faFileCode, faCircleXmark,faFileAudio,faFileVideo,faFileInvoice, faTrashAlt} from '@fortawesome/free-solid-svg-icons';
import { TranscriptionsService } from '../_services/transcriptions.service';
import { saveAs } from 'file-saver';
import { FormGroup, FormControl, Validators} from '@angular/forms';
import { RequestModalService } from '../_shared/request-modal.service';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NavigationExtras, Router } from '@angular/router';
import {TokenStorageService} from '../_services/token-storage.service';
import {MessageService} from 'primeng/api';
import { PrimeNGConfig } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../_services/auth.service';
import { Toast } from 'primeng/toast';
import { Observable, Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { faYoutube, faFacebook, faTwitter, faTiktok } from '@fortawesome/free-brands-svg-icons';

interface currentUploadFile {
  file: File;
  uploadId: string;
}


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})



export class HomeComponent implements OnInit, AfterViewInit, OnDestroy {
  currentUploadFiles:currentUploadFile[];
  uploadProgress:Map<string, number>;
  transcodingFiles: Set<string>;
  downloadProgress:Map<string, number>;
  downloadEvents:Map<string, Subscription>;
  globalPollingInterval: any = null;
  readonly globalPollingIntervalMs = 2000;
  downloadFormatList = ['docx','json','srt'];
  selectedDownloadFormat:string;
  faDocumentWord = faFileWord;
  faDocumentCode = faFileCode;
  faDocumentSubtitle = faFileInvoice;
  faEye = faEye;
  faTrash = faTrash;
  faDownload = faDownload;
  faFolder = faFolderPlus;
  faCircleX = faCircleXmark;
  faFileAudio = faFileAudio;
  faFileVideo = faFileVideo;
  faTrashAlt = faTrashAlt;

  fileUploadUrl: string = '';
  faYoutube = faYoutube;
  faFacebook = faFacebook;
  faTwitter = faTwitter;
  faTiktok = faTiktok;

  uploadInProgress = false;
  audioTable: AudioFile[];
  audioFiles:any;
  jobs: Job[];
  displayedColumns: string[] = ['fileName', 'length', 'createdDate', 'asrDomain', 'status', 'actions'];
  myForm = new FormGroup({
    name: new FormControl('', [Validators.required, Validators.minLength(3)]),
    file: new FormControl('', [Validators.required]),
    fileSource: new FormControl('', [Validators.required])
  });
  bodyText: string;
  crtRequestAudioFile: AudioFile;
  asrDomainList: {}[];
  selectedAsrDomain: any = {};
  postProcessing: boolean = true;
  dataSource: any;
  crtFilter = '';
  checked_token_time:any ;
  isDragOver = false;

  constructor(
    public authService: AuthService,
    private audioTableService : AudioTableService,
    private translate: TranslateService,
    private messageService: MessageService, 
    private tokenStorage: TokenStorageService,
    private transcriptionsService: TranscriptionsService,
    private http: HttpClient,
    private requestModalService: RequestModalService,
    private _liveAnnouncer: LiveAnnouncer,
    private primengConfig: PrimeNGConfig,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private snackBar: MatSnackBar
    ) {
      this.audioTable = [];
      this.jobs = [];
      this.bodyText = '';
      this.crtRequestAudioFile = {};
      this.asrDomainList = [];
      this.currentUploadFiles = [];
      this.downloadProgress = new Map<string, number>();
      this.downloadEvents = new Map<string, Subscription>();
      this.uploadProgress = new Map<string, number>();
      this.transcodingFiles = new Set<string>();
      
  }

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(Toast) toast: Toast;
  @ViewChildren(Toast) toasts!: QueryList<Toast>;
  @ViewChild(Toast, { read: ViewContainerRef, static: true })
  toastRef: ViewContainerRef;

  clear(type: string) {
    try {
      if (this.toasts) {
        this.toasts.forEach(t => {
          if (t && t.messages) {
            t.messages = t.messages.filter((x) => x.id !== type && x.detail !== type);
          }
        });
      } else if (this.toast && this.toast.messages) {
        this.toast.messages = this.toast.messages.filter((x) => x.id !== type && x.detail !== type);
      }
      if (this.toastRef) {
        const changeDetectorRef = this.toastRef.injector.get(ChangeDetectorRef);
        changeDetectorRef.detectChanges();
      }
    } catch (e) {
      console.error(e);
    }
  }

  private normalizeTranscriptionStatus(status?: string): string {
    if (!status) {
      return 'New';
    }

    switch (status.toLowerCase()) {
      case 'in progress':
      case 'processing':
      case 'progress':
        return 'progress';
      case 'completed':
        return 'completed';
      case 'error':
      case 'failed':
        return 'error';
      case 'new':
        return 'New';
      default:
        return status;
    }
  }

  private hasActiveTranscription(audioElement: AudioFile): boolean {
    return !!audioElement.transcriptionJobId && ['New', 'progress'].includes(this.normalizeTranscriptionStatus(audioElement.status));
  }

  private applyJobData(audioElement: AudioFile, jobElement: any): void {
    audioElement.asrDomain = jobElement.asrDomainName;
    audioElement.status = this.normalizeTranscriptionStatus(jobElement.status);
    audioElement.transcriptionJobId = jobElement.jobId;
    audioElement.createdDate = jobElement.createdDate;
  }

  private refreshAudioTable(): void {
    this.dataSource = new MatTableDataSource(this.audioTable);
    
    // Override the default string sort to compare actual Date timestamps mathematically
    this.dataSource.sortingDataAccessor = (item: any, property: string) => {
      if (property === 'createdDate') {
        return item.createdDate ? new Date(item.createdDate).getTime() : 0;
      }
      return item[property];
    };

    if (this.sort) {
      this.sort.active = 'createdDate';
      this.sort.direction = 'desc';
      this.dataSource.sort = this.sort;
    }

    this.dataSource.filter = this.crtFilter.trim().toLocaleLowerCase();

    this.cdr.detectChanges();
  }

  private markTranscriptionAsStarted(jobId: number): void {
    const selectedDomainName = this.selectedAsrDomain?.name || '';
    const newAudioRow = this.audioTable.find((audioElement) => audioElement.audioId === this.crtRequestAudioFile.audioId && audioElement.status === 'New');

    if (newAudioRow) {
      newAudioRow.asrDomain = selectedDomainName;
      newAudioRow.status = 'progress';
      newAudioRow.transcriptionJobId = jobId;
      newAudioRow.createdDate = new Date().toISOString();
      this.crtRequestAudioFile = newAudioRow;
    } else {
      const tmpAudioJob: AudioFile = {
        createdDate: new Date().toISOString(),
        fileName: this.crtRequestAudioFile.fileName,
        length: this.crtRequestAudioFile.length,
        userId: this.crtRequestAudioFile.userId,
        asrDomain: selectedDomainName,
        status: 'progress',
        transcriptionJobId: jobId,
        audioId: this.crtRequestAudioFile.audioId
      };

      this.audioTable.push(tmpAudioJob);
      this.crtRequestAudioFile = tmpAudioJob;
    }

    this.refreshAudioTable();
  }

  ngOnInit(): void {
    this.primengConfig.ripple = true;
    this.selectedDownloadFormat = 'docx';
    this.checked_token_time = new Date();
    this.transcriptionsService.getAsrDomains().subscribe({
      next: (dataAsrDomains: { body: any; }) => {
        let asrDomain =  dataAsrDomains.body[0].name;
        this.audioTableService.getAudioTable().subscribe({
          next: (data: { body: any; }) => {
            this.audioFiles = JSON.parse(JSON.stringify(data.body));
            
            this.transcriptionsService.getAllTranscriptionJobs().subscribe({
              next: (dataJobs: { body: any; }) => {
                this.jobs = JSON.parse(JSON.stringify(dataJobs.body));
                
                this.rebuildAudioTable();
                
                // Start global polling if needed
                this.startGlobalTranscriptionsPolling();
              },
              error: (err: any) => {
                console.log(err);
                this.jobs = [];
                return null;
              }
            });
          },
          error: (err: any) => {
            this.audioTable = [];
            console.log(err);
            return null;
          }
        });
      },
      error: (err: any) => {
        console.log(err);
        this.jobs = [];
        return null;
      }
    })
  }

  ngAfterViewInit() {
    if (this.sort && this.dataSource) {
      this.sort.active = 'createdDate';
      this.sort.direction = 'desc';
      this.dataSource.sort = this.sort;
    }
  }

  updateAudioFileStatus(audioId: number) {
    
    this.transcriptionsService.getAllTranscriptionJobs().subscribe({
      next: (dataJobs: { body: any; }) => {
        this.jobs = JSON.parse(JSON.stringify(dataJobs.body));
        let hasUpdates = false;
        for(var audioElement of this.audioTable) {
          if(audioId == audioElement.transcriptionJobId) {
            for (var jobElement of this.jobs) { 
              if(audioId == jobElement.jobId) {
                this.applyJobData(audioElement, jobElement);
                hasUpdates = true;
              }
            }
          }
        }

        if (hasUpdates) {
          this.refreshAudioTable();
        }
      },
      error: (err: any) => {
        console.log(err);
        this.jobs = [];
        return null;
      }
    });
  }

  onRejectDownload(downloadId:string){
    this.downloadEvents.get(downloadId).unsubscribe();
    this.clear(downloadId);
    this.downloadEvents.delete(downloadId)
    this.downloadProgress.delete(downloadId);
  }

  onRejectUpload(uploadId: string){
    this.uploadProgress.set(uploadId, -1);
    this.clear(uploadId);
  }

 downloadAudioFile(audioId: number, fileName: string){
    
    let downloadId = Math.random()+audioId+"_"+fileName;
    this.downloadProgress.set(downloadId,0);
    
    this.translate.get('home.downloadProgress').subscribe((res: string) => { this.messageService.add({ id:downloadId, key:"download", severity:'info', summary: res+" " + fileName, detail: downloadId, sticky:true, closable:false});});

    this.downloadEvents.set(downloadId,
    this.audioTableService.getAudioFile(audioId).subscribe({
      next: (event: any) => {
        console.log("Download event:", event.type, event);
        if (event.type === HttpEventType.DownloadProgress){
          this.downloadProgress.set(downloadId,Math.round(100 * event.loaded / (event.total || event.loaded)));
        }

        if (event.type === HttpEventType.Response) {
          console.log("Download completed. Creating Blob.");
          this.clear(downloadId);
          const blob = new Blob([event.body], { 'type' : 'application/octet-stream' });
          saveAs(blob, fileName);
          this.downloadEvents.delete(downloadId)
          this.downloadProgress.delete(downloadId);
        }
      },
      error: (err: any) => {
        this.clear(downloadId);
        this.downloadEvents.delete(downloadId);
        this.downloadProgress.delete(downloadId);
        console.error("Download failed:", err);
      }
    })
   )
  }

  downloadTranscriptionFile(id:string, jobId: number, fileName: string, format:string): void {

    this.audioTableService.getAudioTranscription(jobId,format).subscribe({
      next: (dataFile: { body: any; }) => {
        const blob = new Blob([dataFile.body], { 'type' : 'text/json' });
        fileName = fileName.replace('.',"_");
        fileName = fileName.concat('.'+format);
        saveAs(blob, fileName);
        this.closeModal(id);
        
      },
      error: (err: any) => {
        console.log(err);
        return null;
      }
    });
  }


  deleteAudioFile(audioId: number): void {
    let crtAudioTable: AudioFile[] = [];
    this.audioTableService.deleteAudioFile(audioId).subscribe({
      next: (dataFile: { body: any; }) => {
        this.audioTable.forEach((element,index)=>{
          if(element.audioId!=audioId)  {
            crtAudioTable.push(element);
          }else{
            this.translate.get('home.deleteFile').subscribe((res: string) => { this.messageService.clear(); let message = res.split(":");this.messageService.add({ severity:'warn', summary: message[0], detail: message[1]+element.fileName});});
          }
        });
        this.audioTable = crtAudioTable;
        this.refreshAudioTable();
       
        //this.applyFilter(this.crtFilter);
      },
      error: (err: any) => {
        console.log(err);
        return null;
      }
    });
  }

  deleteTranscription(jobId: number, audioId: number): void {
    this.transcriptionsService.deleteTranscription(jobId).subscribe({
      next: (dataFile: { body: any; }) => {
        this.translate.get('home.deleteTranscriptionSuccess').subscribe((res: string) => {
          this.messageService.clear();
          let message = res.split(":");
          this.messageService.add({ severity:'warn', summary: message[0], detail: message[1]});
        });
        
        // Refresh the job list from backend to get accurate statuses
        this.scheduleAudioTableRefresh();
      },
      error: (err: any) => {
        console.log(err);
        this.translate.get('home.deleteTranscriptionFailed').subscribe((res: string) => {
          this.messageService.clear();
          let message = res.split(":");
          this.messageService.add({ severity:'error', summary: message[0], detail: message[1]});
        });
        return null;
      }
    });
  }

  private rebuildAudioTable(): void {
    let newAudioTable: AudioFile[] = [];
    
    for (var audioElement of this.audioFiles) {
      let newFile = true;
      for (var jobElement of this.jobs) {
        if(audioElement.audioId == jobElement.audioId) {
          const tmpAudioJob: AudioFile = {
            createdDate: jobElement.createdDate,
            fileName: audioElement.fileName,
            length: audioElement.length,
            userId: audioElement.userId,
            asrDomain: jobElement.asrDomainName,
            status: this.normalizeTranscriptionStatus(jobElement.status),
            transcriptionJobId: jobElement.jobId,
            audioId: audioElement.audioId
          }
          newFile = false;
          newAudioTable.push(tmpAudioJob);
        }
      }
      
      if(newFile) {
        const tmpAudioJob: AudioFile = {
          createdDate: audioElement.createdDate,
          fileName: audioElement.fileName,
          length: audioElement.length,
          userId: audioElement.userId,
          asrDomain: '',
          status: 'New',
          transcriptionJobId: null,
          audioId: audioElement.audioId
        }
        newAudioTable.push(tmpAudioJob);
      }
    }
    
    this.audioTable = newAudioTable;
    this.refreshAudioTable();
  }

  onFileChange(event:any) {
    
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.myForm.patchValue({
        fileSource: file
      });
      
      //this.uploadSubmit(file);
      event.target.value="";
    }
  }
  
  
  uploadFromUrl(url: string): void {
    // Regular expression for URL validation
    const urlRegex = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:[0-9]{1,5})?(\/.*)?$/;
  
    // Validate URL
    if (!url || url.trim() === '' || !urlRegex.test(url.trim())) {
      this.translate.get('home.invalidURL').subscribe((res: string) => { 
        this.messageService.clear(); 
        const [summary, detail] = res.split(":");
        this.messageService.add({ severity: 'warn', summary, detail, sticky: true });
      });
      this.fileUploadUrl = '';
      return;
    }

    this.uploadInProgress = true;
  
    // Make HTTP request
    this.audioTableService.uploadByUrl(url).subscribe(
      (response: any) => {
        // Success handler
        this.translate.get('home.uploadSuccess').subscribe((res: string) => { 
          const [summary, detail] = res.split(":");
          this.messageService.add({ severity: 'success', summary, detail });
        });
        this.fileUploadUrl = '';
        
        // Update the audio files table by inserting the new file
        const tmpAudioJob :AudioFile ={
          createdDate : response.createdDate || new Date().toISOString(),
          fileName : response.fileName,
          length : response.length,
          userId : response.userId,
          asrDomain : '',

          status :'New',
          transcriptionJobId : null,
          audioId : response.audioId
          
          }
        this.audioTable.push(tmpAudioJob);
        this.refreshAudioTable();
        this.uploadInProgress = false;
        return;
      },
      (error) => {
        // Error handler
        this.translate.get('home.uploadFailed').subscribe((res: string) => { 
          const [summary, detail] = res.split(":"); 
          this.messageService.add({ severity: 'error', summary, sticky: true }); 
        });
        console.error('Error uploading file from URL:', error);
        this.fileUploadUrl = '';

        this.uploadInProgress = false;
      }
    );
  }
  




  async uploadSubmit(file: any,uploadId:string){
    //this.uploadInProgress = true;
    // const formData = new FormData();
    // formData.append('audioFile', this.myForm.get('fileSource')?.value,this.myForm.get('fileName')?.value);
    // this.audioTableService.uploadAudioFile(formData).subscribe({
    //   next: (uploadedFile: { body: any; }) => {
    //     this.ngOnInit();
    //     this.uploadInProgress = false;
    //   },
    //   error: (err: any) => {
    //     this.uploadInProgress = false;
    //     console.log(err);
    //     alert(err.error.message);
    //     return null;
        
    //   }
    // })
    if (file.name.toLowerCase().includes(".m4a") || file.name.toLowerCase().includes(".mp4") || file.name.toLowerCase().includes(".mp3") || file.name.toLowerCase().includes(".wav")){
    let filename_parsed = file.name.normalize("NFD").replaceAll(/[^\x20-\x7E]/g, "").replaceAll(" ","_").replaceAll(/[&\/\\#,+()$~%'"":*?<>{}]/g, "");
    this.uploadProgress.set(uploadId,0);
    let crtUploadFile = {"file":file,"uploadId":uploadId};
    this.currentUploadFiles.push(crtUploadFile);
    this.translate.get('home.uploadProgress').subscribe((res: string) => { this.messageService.add({ id:uploadId, key:"upload", severity:'info', summary: res + file.name, detail: uploadId, sticky:true, closable:false});});
    this.cdr.detectChanges();
    const chunkSize_max = 2000000;
    let errorMessage = "";
    let chunkSize = Math.round(file.size/5);
    if (chunkSize >chunkSize_max) chunkSize = chunkSize_max;
    let hasErrors = false;
    for( let offset = 0; offset < file.size; offset += chunkSize ){
      //console.log(this.uploadProgress.get(uploadId))
      if (this.uploadProgress.get(uploadId)>-1){
        this.uploadProgress.set(uploadId,(offset/file.size)*100);
        this.cdr.detectChanges();
        if ((offset + chunkSize)<file.size){
          const chunk = file.slice( offset, offset + chunkSize );
          const formData = new FormData();
          formData.append("file", chunk);
          try {
          await this.audioTableService.uploadMediaFileChunk(filename_parsed,uploadId, formData,offset,offset + chunkSize, file.size );
          } catch(error){
            console.log(error)
            hasErrors = true
            if(error.error.message){
            errorMessage = error.error.message;
            }else{
              errorMessage = error.message;
            }
            break
          }
        }else{
          const chunk = file.slice( offset, file.size );
          const formData = new FormData();
          formData.append("file", chunk);
          try {
          this.transcodingFiles.add(uploadId);
          this.cdr.detectChanges();
          let data = await this.audioTableService.uploadMediaFileChunk(filename_parsed,uploadId, formData,offset,file.size, file.size );
          }catch(error){
            hasErrors = true
            if(error.error.message){
              errorMessage = error.error.message;
              }else{
                errorMessage = error.message;
              }
            break
          }
        }
      
        
      }
      else{
        this.uploadProgress.delete(uploadId);
        hasErrors = true;
        errorMessage = 'cancel'
      }
      //console.log(this.uploadProgress.get(uploadId))
    }
    if (hasErrors){
      this.transcodingFiles.delete(uploadId);
      this.clear(uploadId);
      if (errorMessage!='cancel'){
        this.translate.get('home.uploadFailed').subscribe((res: string) => { let message = res.split(":");this.messageService.add({ severity:'warn', summary: message[0], detail: crtUploadFile.file.name+" - "+message[1]+ ": "+errorMessage, sticky:true});});
      }
      this.removeFile(crtUploadFile);
      this.uploadProgress.delete(uploadId);
      this.cdr.detectChanges();

    }else{
      this.transcodingFiles.delete(uploadId);
      this.uploadProgress.set(uploadId,100);
      this.cdr.detectChanges();
      this.clear(uploadId);
      this.translate.get('home.uploadSuccess').subscribe((res: string) => { let message = res.split(":");this.messageService.add({ severity:'success', summary: message[0], detail: crtUploadFile.file.name+": "+message[1]});});
      this.removeFile(crtUploadFile);
      this.uploadProgress.delete(uploadId);
      this.scheduleAudioTableRefresh();
      this.cdr.detectChanges();
     
    }
    //this.uploadInProgress = false;
    }else{
      this.translate.get('home.invalidFileType').subscribe((res: string) => { this.messageService.clear(); let message = res.split(":");this.messageService.add({ severity:'warn', summary: message[0], detail: message[1], sticky:true});});
    }

  }

  sendRequest(id: string) {
    //console.log("Request for audio:" + this.crtRequestAudioFile.fileName);
    //console.log("Selected Asr Domain:" + this.selectedAsrDomain['asrDomainId']);
    if(this.crtRequestAudioFile.audioId != undefined) {
      this.transcriptionsService.postAutomaticSpeechRequest(
        this.selectedAsrDomain['asrDomainId'], this.postProcessing, this.crtRequestAudioFile.audioId).subscribe({
        next: (response: { body: any; }) => {
          if (response.body.status == undefined) {
            const jobId = response.body["Job ID"];
            this.markTranscriptionAsStarted(jobId);
            this.updateAudioFileStatus(jobId);
            this.startGlobalTranscriptionsPolling();
          } else {
            this.translate.get('home.transcriptionAlreadyDone').subscribe((res: string) => { this.messageService.clear(); let message = res.split(":");this.messageService.add({ severity:'warn', summary: message[0], detail: message[1] , sticky:true});});
          }
        },
        error: (err: any) => {
          let errorMessage = "";
          if(err.error.message){
             errorMessage = err.error.message;
            }else{
              errorMessage = err.message;
            }
          this.translate.get('home.transcriptionFailed').subscribe((res: string) => { this.messageService.clear(); let message = res.split(":");this.messageService.add({ severity:'warn', summary: message[0], detail: message[1]+ ": " +errorMessage, sticky:true});});
          console.log(err);
          return null;
        }
      });
    }
    this.closeModal(id);
  }

  startGlobalTranscriptionsPolling(): void {
    const hasProgressJobs = this.audioTable.some((audioElement) => this.hasActiveTranscription(audioElement));

    if (hasProgressJobs && !this.globalPollingInterval) {
      this.globalPollingInterval = setInterval(() => {
        this.transcriptionsService.getAllTranscriptionJobs().subscribe({
          next: (dataJobs: { body: any; }) => {
            if (!dataJobs || !dataJobs.body) return;
            this.jobs = JSON.parse(JSON.stringify(dataJobs.body));
            let stillRunning = false;
            let hasUpdates = false;

            for (let audioElement of this.audioTable) {
              if (audioElement.transcriptionJobId) {
                const jobElement = this.jobs.find((j: any) => j.jobId === audioElement.transcriptionJobId);
                if (jobElement) {
                  const normalizedStatus = this.normalizeTranscriptionStatus(jobElement.status);
                  const hasRowChanges = audioElement.asrDomain !== jobElement.asrDomainName
                    || audioElement.status !== normalizedStatus
                    || audioElement.transcriptionJobId !== jobElement.jobId
                    || audioElement.createdDate !== jobElement.createdDate;

                  if (hasRowChanges) {
                    this.applyJobData(audioElement, jobElement);
                    hasUpdates = true;
                  }
                }
              }

              if (this.hasActiveTranscription(audioElement)) {
                stillRunning = true;
              }
            }

            if (hasUpdates) {
              this.refreshAudioTable();
            }

            if (!stillRunning) {
              this.stopAllPolling();
            }
          },
          error: (err: any) => {
            console.log("Polling error:", err);
          }
        });
      }, this.globalPollingIntervalMs);
    }
  }

  startPollingForActiveTranscriptions(): void {
    this.startGlobalTranscriptionsPolling();
  }

  stopPollingForTranscription(jobId: number): void {
    // Replaced by global polling stop
  }

  stopAllPolling(): void {
    if (this.globalPollingInterval) {
      clearInterval(this.globalPollingInterval);
      this.globalPollingInterval = null;
    }
  }

  navigateToTranscription(jobId: number, audioId: number, fileName: string, asrDomain: string, length:any) {
    
    let navigationExtras: NavigationExtras = {
      queryParams: {
        "jobId": jobId,
        "audioId": audioId,
        "fileName": fileName,
        "asrDomain": asrDomain,
        "length":length
      }
    };
    this.router.navigate(['/transcription'], navigationExtras);
  }

  openModal(id: string, audioFileInput: AudioFile) {
    this.selectedDownloadFormat = 'docx';
    this.asrDomainList = [];
    this.transcriptionsService.getAsrDomains().subscribe({
      next: (dataAsrDomains: { body: any; }) => {
        dataAsrDomains.body.forEach((element)=>this.asrDomainList.push(element));
        this.crtRequestAudioFile = audioFileInput;
        this.selectedAsrDomain = this.asrDomainList[0];
        this.requestModalService.open(id);
      },
      error: (err: any) => {
        console.log(err);
        return null;
      }
    });
  }

  openModalUpload(id: string){
    this.requestModalService.open(id);
  } 

  onFileDrop(event: DragEvent){
    event.preventDefault();
    this.isDragOver = false;
    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      this.processUploadFiles(files);
    }
  }

  onUploadFilesChange(event:any){
    const files = event.target.files;
    if (!files || files.length === 0) return;
    this.processUploadFiles(files);
    event.target.value = '';
  }

  private processUploadFiles(files: FileList){
      let hasValidFiles = false;
      for (var i = 0; i <= files.length - 1; i++) {
        var selectedFile = files[i];
        
        // Prevent duplicate concurrent uploads (e.g. drop and change events firing together)
        const isCurrentlyUploading = this.currentUploadFiles.some(f => f.file.name === selectedFile.name && f.file.size === selectedFile.size);
        if (isCurrentlyUploading) {
            continue;
        }

        if (selectedFile.name.toLowerCase().includes(".m4a") || selectedFile.name.toLowerCase().includes(".mp4") || selectedFile.name.toLowerCase().includes(".mp3") || selectedFile.name.toLowerCase().includes(".wav")){
          const uploadId = selectedFile.name.normalize("NFD").replaceAll(/[^\x20-\x7E]/g, "").replaceAll(" ","_").replaceAll(/[&\/\\#,+()$~%'"”:*?<>{}]/g, "")+ Math.random();
          this.uploadSubmit(selectedFile,uploadId);
          hasValidFiles = true;
        }else{
          this.translate.get('home.invalidFileType').subscribe((res: string) => { this.messageService.clear(); let message = res.split(":");this.messageService.add({ severity:'warn', summary: message[0], detail: selectedFile.name+": "+message[1], sticky:true});});
        }
      }
      if (hasValidFiles) {
        this.requestModalService.close('custom-modal-3');
      }
  }

  removeFile(crtFile: currentUploadFile){
    this.uploadProgress.set(crtFile.uploadId,-1);
    for (var i = 0; i <= this.currentUploadFiles.length - 1; i++) {
      if(crtFile.file.name==this.currentUploadFiles[i].file.name){
        this.currentUploadFiles.splice(i,1);
      } 
  }
    this.cdr.detectChanges();
    
  }

  refreshTable(): void {
    this.ngOnInit();
  }

  private scheduleAudioTableRefresh() {
    this.ngOnInit();
    setTimeout(() => {
      this.ngOnInit();
      this.cdr.detectChanges();
    }, 1500);
  }

  closeModal(id: string) {
    this.requestModalService.close(id);
    if (id=="custom-modal-3"){
      this.currentUploadFiles=[];
    }
  }

  announceSortChange(sortState: Sort) {
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  applyFilter(filterValue: string) {
    this.crtFilter = filterValue || '';

    if (this.dataSource) {
      this.dataSource.filter = this.crtFilter.trim().toLocaleLowerCase();
    }
  }

  clearFilter(): void {
    this.applyFilter('');
  }


  checkTokenFromStorage(){
    if (!!!this.tokenStorage.getToken()){
      this.translate.get('autoLogoutMessage').subscribe((res: string) => { this.messageService.clear(); let message = res.split(":");this.messageService.add({ severity:'warn', summary: message[0], detail: message[1], sticky:true});});
      this.tokenStorage.signOut();
      setTimeout(()=>{this.router.navigate(['/']);window.location.reload()},2000);
    }else{
    let current_time = new Date();
    let request_timeout = 10000;
    if ((current_time.getTime()-this.checked_token_time.getTime())>request_timeout){
      this.authService.info().subscribe({
        next: (data) => {

        },
        error:(data) => {
          this.translate.get('autoLogoutMessage').subscribe((res: string) => { this.messageService.clear(); let message = res.split(":");this.messageService.add({ severity:'warn', summary: message[0], detail: message[1], sticky:true});});
          this.tokenStorage.signOut();
          setTimeout(()=>{this.router.navigate(['/']);window.location.reload()},2000);
        }
      })
      this.checked_token_time = current_time;
    }
  
    }
    
  }

  ngOnDestroy(): void {
    // Clean up all polling intervals when component is destroyed
    this.stopAllPolling();
  }
  
}
